import React, { useState, useMemo, useRef } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

type Props = {
    latitude?: number;
    longitude?: number;
    onChange: (coords: { latitude: number; longitude: number }) => void;
};

const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
};

const DEFAULT_CENTER = { lat: 32.1167, lng: 20.0667 }; 

const mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    
};

const LocationPicker: React.FC<Props> = ({ latitude, longitude, onChange }) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: "AIzaSyAR-gDcgLPsnghASqrd5UHWOthgTjQ41jg" ,
    });

    const mapRef = useRef<google.maps.Map | null>(null);

    const initialCenter = useMemo(() => {
        if (latitude && longitude) {
            return { lat: latitude, lng: longitude };
        }
        return DEFAULT_CENTER;
    }, [latitude, longitude]);

    const [markerPosition, setMarkerPosition] = useState<{ lat: number; lng: number } | null>(
        latitude && longitude ? { lat: latitude, lng: longitude } : null
    );

    const handleMapClick = (e: google.maps.MapMouseEvent) => {
        const lat = e.latLng?.lat();
        const lng = e.latLng?.lng();
        if (lat && lng) {
            const newPosition = { lat, lng };
            setMarkerPosition(newPosition);
            onChange({ latitude: lat, longitude: lng });
            if (mapRef.current) {
                mapRef.current.panTo(newPosition);
            }
        }
    };

    if (!isLoaded) return <div className="text-gray-500">جارٍ تحميل الخريطة...</div>;

    return (
        <div className="mt-4 mb-5">
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={markerPosition || initialCenter}
                zoom={12}
                options={mapOptions}
                onClick={handleMapClick}
                onLoad={(map) => {
                    mapRef.current = map;
                }}
            >
                {markerPosition && (
                    <Marker
                        position={markerPosition}
                        animation={google.maps.Animation.DROP} 
                    />
                )}
            </GoogleMap>
        </div>
    );
};

export default LocationPicker;
